module.exports = __webpack_public_path__ + "static/img/nakazawa_01.784496b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/nakazawa_01.png
// module id = sUns
// module chunks = 0